import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, map } from "rxjs";
import { JourneyQuestion } from "../models/journey-question.model";
import { environment } from "../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class ResponseService {
  private baseApiUrl = environment.questionnaireApiUrl;
  // private baseApiUrl = "http://localhost:3000/api";
  private responsesUrl = `${this.baseApiUrl}/responses`;
  private userUrl = `${this.baseApiUrl}/user/responses`;

  constructor(private http: HttpClient) {}

  getQuestionnaireByUserId() {
    const url = `${this.userUrl}/without-responses`;
    return this.http.get(url);
  }

  initializeQuestionnaireResponse(templateId: string): Observable<any> {
    const payload = { templateId };

    const url = `${this.responsesUrl}`; // Define the API endpoint URL for creating responses

    // Make a POST request to create a new questionnaire response
    return this.http.post(url, payload);
  }

  /**
   * Method to store questionnaire responses
   * @param questionnaireId The ID of the questionnaire
   * @param responses The array of responses to be stored
   * @returns Observable with the server response
   */
  storeResponses(
    questionnaireId: string,
    responses: {
      sectionId: string;
      subsectionId: string;
      questionId: string;
      answer: string | string[] | null;
    }[]
  ): Observable<any> {
    const payload = { responses }; // Prepare the payload
    const url = `${this.responsesUrl}/${questionnaireId}`; // Construct the API endpoint URL

    // Make a POST request to store responses
    return this.http.post(url, payload);
  }

  setUserEligibility(
    questionnaireId: string,
    eligibility: boolean,
    message = ""
  ) {
    const payload = { message, eligibility };
    const url = `${this.responsesUrl}/${questionnaireId}/eligibility`;
    return this.http.put(url, payload);
  }

  getQuestionnaireResponsesByQuestionnaireId(
    questionnaireId: string,
    subsectionId: string | null = null
  ): Observable<JourneyQuestion[]> {
    let url = `${this.responsesUrl}/${questionnaireId}/with-responses`;
    
    // Add subsectionId as query parameter if provided and not null
    if (subsectionId !== null) {
      url += `?subsectionId=${subsectionId}`;
    }
    
    return this.http.get<any>(url).pipe(
      map((response) => {
        // Map the API response to the desired format
        return response.responses.map((res: any) => ({
          sectionName: res.sectionName,
          questionId: res.questionId,
          questionType: res.questionType || res.question_type,
          questionText: res.questionText,
          answerText: res.responseText,
        }));
      })
    );
  }
}
